import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withTranslation } from 'react-i18next'

import { colors } from '../../../../../constants'

const Button = styled.button`
    background: white;
    border: 0;
    border-radius: 5px;
    color: ${colors.bluedark};
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 2px 2px 10px;
    outline: none;
    text-transform: lowercase;
    transform: scaleX(0);
    transform-origin: right;
    vertical-align: top;
    width: 0;

    ${({ show }) =>
        show &&
        `
      transform: scaleX(1);
      width: auto;
      transition: all 0.3s;
    `}
`

const ClearFiltersIcon = styled.div`
    background: ${colors.bluedark};
    border-radius: 5px;
    color: white;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    height: 20px;
    outline: none;
    margin: 0;
    margin-left: 5px;
    width: 20px;
`

const TimesIcon = styled(FontAwesomeIcon)`
    vertical-align: bottom;
`

const ClearFiltersButton = ({ onClick, show, t }) => (
    <Button title="Clear Filters" onClick={onClick} show={show}>
        {t('Clear filters')}
        <ClearFiltersIcon>
            <TimesIcon icon="times" />
        </ClearFiltersIcon>
    </Button>
)

ClearFiltersButton.propTypes = {
    onClick: PropTypes.func,
    show: PropTypes.bool,
    t: PropTypes.func.isRequired,
}

ClearFiltersButton.defaultProps = {
    onClick: false,
    show: () => null,
}

export default withTranslation()(ClearFiltersButton)
